import { Navigate, Outlet } from 'react-router';
import { getLocalStorage } from '../utils/localstorage';

const RequireAuth = () => {
  const auth = getLocalStorage('tokens');
  if (!auth) {
    return <Navigate to='/' />;
  }

  return <Outlet />;
};
export default RequireAuth;
